module.exports = __webpack_public_path__ + "static/media/icon-soundcloud.b90768ed.svg";